import { HStack } from 'native-base';
import { useTranslation } from 'react-i18next';
import { useSiteConfig } from '@app/features/store-core';

import { Text } from '@pimm/base';
import { DefaultCultures } from '@app/utils/consts';
import { DropdownCultures } from './dropdown-cultures';

export const SelectLanguage = () => {
  const { t } = useTranslation();

  return (
    <HStack space={2} alignItems="center">
      <Text size="sm" fontWeight={600} color="black">
        {t('access:select_language')}
      </Text>
      <DropdownCultures variant="contained" cultures={DefaultCultures} hasBorder />
    </HStack>
  );
};
